import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-mail',
  templateUrl: './icon-email.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEmailComponent {}
